import styled, { css } from "styled-components";

export const SpinnerStyle = css`
  @keyframes modalLoaderAnimation {
    from {
      transform: translate(-50%, -50%) rotate(0deg);
    }

    to {
      transform: translate(-50%, -50%) rotate(360deg);
    }
  }
`;

interface StyleProps {
  $isVisible: boolean;
}

export const DivProductModal = styled.span<StyleProps>`
  height: 100%;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5) !important;
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  position: fixed;
  top: 0;
  left: 0;

  ${({ $isVisible }) => !$isVisible && `display:none;`}

  & {
    .akn-modal-details {
      padding: 18px;
      display: flex;
      flex-direction: column;
      height: 100%;
      background: #fff;
    }

    .akn-modal-close {
      position: absolute;
      padding: 5px 15px;
      color: #333333;
      cursor: pointer;
      font-size: 16px;
      z-index: 11;
      right: 0;
      top: 4px;
      user-select: none;
      &:hover {
        color: #000;
      }
    }

    .akn-modal-container-inner {
      position: relative;
      border-radius: 15px;
      overflow: hidden;
      min-width: 300px;
    }
    ${SpinnerStyle}
  }
`;
